import { makeStyles, tokens } from '@fluentui/react-components';
import { WarningRegular } from '@fluentui/react-icons';
import type { Allergen } from '../types/catering';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    flexWrap: 'wrap',
  },
  dot: {
    display: 'inline-flex',
    width: '1.5rem',
    height: '1.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: tokens.borderRadiusCircular,
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightSemibold,
  },
  allergen: {
    backgroundColor: tokens.colorPaletteDarkOrangeBackground3,
  },
});

export type DietaryDotsProps = {
  allergens: Allergen[];
};

function getAllergenNames(allergens: Allergen[]): string[] {
  return allergens.map((allergen) => allergen.name);
}

export function DietaryDots({ allergens }: DietaryDotsProps) {
  const styles = useStyles();
  const allergenNames = getAllergenNames(allergens);
  const labels = allergenNames.map((allergen) => `Contains ${allergen}`);

  if (labels.length === 0) {
    return null;
  }

  return (
    <div className={styles.root} role="img" aria-label={labels.join(', ')}>
      {allergenNames.map((allergen) => (
        <span
          className={`${styles.dot} ${styles.allergen}`}
          key={`allergen-${allergen}`}
          title={`Contains ${allergen}`}
          aria-hidden="true"
        >
          <WarningRegular aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}
